import styles from "./RescheduleScreen.module.scss";

import { useTranslation } from "react-i18next";

import { PageContainer } from "@/modules/shared/components/PageContainer";
import { SessionBookingWidget } from "@/modules/shared/components/SessionBookingWidget";
import { ShortUrlFlow } from "@/modules/tracking/consts/ShortUrl";
import { usePageLoaded } from "@/modules/tracking/hooks/usePageLoaded";
import { useShortUrlFlowAbandonment } from "@/modules/tracking/hooks/useShortUrlFlowAbandonment";
import { Route } from "@/routes/$sessionCode/reschedule/$rescheduleUuid";

export const RescheduleScreen = () => {
  const { t } = useTranslation();
  const {
    data: {
      coach,
      coachName,
      originalSessionId,
      originalSessionStart,
      customer,
      sessionId,
    },
  } = Route.useLoaderData();
  useShortUrlFlowAbandonment();
  usePageLoaded({
    flow: ShortUrlFlow.Reschedule,
    session_id: String(sessionId),
    coach_id: String(coach.id),
    time_until_session_start_minutes: null,
    is_first_visit: true,
    has_joined_previously: false,
  });

  return (
    <PageContainer variant="centered">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.title}>{t("rescheduleSession.title")}</span>
          <span className={styles.subtitle}>
            {t("rescheduleSession.description")}
          </span>
        </div>
        <SessionBookingWidget
          coachId={coach.id}
          coachName={coachName}
          customerId={customer.id}
          rescheduleSessionId={originalSessionId}
          originalSessionStart={originalSessionStart}
          memberName={customer.fullName}
          memberEmail={customer.email}
        />
      </div>
    </PageContainer>
  );
};
